export default __webpack_public_path__ + "static/media/sie-rack-device-persp1-fr-001-39l-ohne-bearbeitet_675x267-freigestellt (002).8272f457.png";